export const UNREAD_MENTIONS_INDICATOR_WRAPPER_TEST_ID =
	'software.unread-mentions-indicator-wrapper';
export const UNREAD_MENTIONS_INDICATOR_TEST_ID = 'software.unread-mentions-indicator';
